export default {
  namespaced: true,
  state: {
    items: JSON.parse(localStorage.getItem('cart_items') || '[]'),
    incotermDAP: JSON.parse(localStorage.getItem('cart_incotermDAP') || 'true'),
    editingOrderNo: JSON.parse(localStorage.getItem('cart_editingOrderNo') || 'null'),
  },
  getters: {
    allItems(state) {
      return state.items
    },
    itemCount(state) {
      return state.items.reduce((sum, item) => sum + item.quantity, 0)
    },
  },
  mutations: {
    addItem(state, item) {
      const existing = state.items.find(i => i.id === item.id)
      if (existing) {
        existing.quantity += item.quantity || 1
      } else {
        state.items.push({
          ...item,
          quantity: item.quantity || 1,
          material: item.material || null,
        })
      }
      localStorage.setItem('cart_items', JSON.stringify(state.items))
    },
    setItemQuantity(state, { id, quantity }) {
      const item = state.items.find(i => i.id === id)
      if (item) {
        item.quantity = quantity
        localStorage.setItem('cart_items', JSON.stringify(state.items));
      }
    },
    decreaseItem(state, id) {
      const existing = state.items.find(i => i.id === id)
      if (existing) {
        if (existing.quantity > 1) {
          existing.quantity--
        } else {
          state.items = state.items.filter(i => i.id !== id)
        }
        localStorage.setItem('cart_items', JSON.stringify(state.items))
      }
    },
    removeItem(state, id) {
      state.items = state.items.filter(i => i.id !== id)
      localStorage.setItem('cart_items', JSON.stringify(state.items))
    },
    updateComment(state, { id, comment }) {
        const item = state.items.find(i => i.id === id)
        if (item) {
            item.comment = comment
            localStorage.setItem('cart_items', JSON.stringify(state.items))
        }
    },
    updateItemAccessDocument(state, { id, document }) {
      const item = state.items.find(i => i.id === id);
      if (item) {
        item.accessDocument = document;
        localStorage.setItem('cart_items', JSON.stringify(state.items));
      }
    },
    updateMaterial(state, { id, material }) {
      const item = state.items.find(i => i.id === id);
      if (item) {
        item.material = material;
        localStorage.setItem('cart_items', JSON.stringify(state.items));
      } else {
        console.warn('Item not found for id:', id);
      }
    },
    setIncotermDAP(state, value) {
      state.incotermDAP = value === true;
      localStorage.setItem('cart_incotermDAP', JSON.stringify(state.incotermDAP));
    },
    setEditingOrderNo(state, orderNo) {
        state.editingOrderNo = orderNo;
        localStorage.setItem('cart_editingOrderNo', JSON.stringify(orderNo));
    },
    clearCart(state) {
      state.items = [];
      state.incotermDAP = true;
      state.editingOrderNo = null;
      localStorage.removeItem('cart_items');
      localStorage.removeItem('cart_incotermDAP');
      localStorage.removeItem('cart_editingOrderNo');
    },
    setItems(state, items) {
      state.items = items;
      localStorage.setItem('cart_items', JSON.stringify(items));
    },
  },
  actions: {
    addItem({ commit }, item) {
      commit('addItem', item)
    },
    decreaseItem({ commit }, id) {
      commit('decreaseItem', id)
    },
    removeItem({ commit }, id) {
      commit('removeItem', id)
    },
    setIncotermDAP({ commit }, value) {
      commit('setIncotermDAP', value);
    },
    clearCart({ commit }) {
      commit('clearCart')
    }
  }
}
